import React from "react";
import styled from "styled-components";
import { color } from "styles/colours";
import { types, Repeater } from "react-bricks/frontend";
import { mobile } from "components/templates/Breakpoints";
import { getVerticalPadding, VerticalPadding, verticalPadSideProp } from "../utils/verticalPadding";

export interface TextWithImageItemProps {
  reverse: boolean;
  paddingVertical?: VerticalPadding;
  backgroundColor: types.IColor;
}

export const TextWithForm: types.Brick<TextWithImageItemProps> = ({
  reverse = false,
  paddingVertical,
  backgroundColor,
}) => {
  return (
    <Container
      reverse={reverse}
      pad={getVerticalPadding(paddingVertical)}
      backgroundColor={backgroundColor?.color}
    >
      <TextContainer>
        <Repeater propName="copyBlock" />
      </TextContainer>

      <FormContainer>
        <Repeater propName="form" />
      </FormContainer>
    </Container>
  );
};

TextWithForm.schema = {
  name: "text-with-form",
  label: "Form capture",
  previewImageUrl: "/static/bricks/form-capture.png",
  getDefaultProps: () => ({
    verticalPadding: "s",
    eyebrowColor: { color: color.S3100 },
    backgroundColor: { color: color.white },
    image: {
      src: "https://assets.reactbricks.com/wqzbqeh9bMnAhYE/images/original/Au2Awpxyb4CFVLP/today-screen.webp",
    },
  }),
  repeaterItems: [
    {
      name: "copyBlock",
      itemType: "text-with-heading-block",
      itemLabel: "Copy",
      min: 1,
      max: 1,
    },
    {
      name: "form",
      itemType: "hubspot-form",
      itemLabel: "Hubspot form",
      min: 1,
      max: 1,
    },
  ],
  sideEditProps: [
    {
      name: "reverse",
      label: "Reverse layout",
      type: types.SideEditPropType.Boolean,
      shouldRefreshStyles: true,
    },
    {
      name: "backgroundColor",
      label: "Background Color",
      type: types.SideEditPropType.Select,
      shouldRefreshStyles: true,
      selectOptions: {
        display: types.OptionsDisplay.Color,
        options: [
          { value: { color: color.white }, label: "White" },
          { value: { color: color.B210 }, label: "Gray" },
        ],
      },
    },
    verticalPadSideProp,
  ],
};

const ZIG_ZAG_BREAKPOINT = `@media only screen and (max-width: 76rem)`;

const Container = styled.div<{
  reverse: boolean;
  pad?: string;
  backgroundColor: string;
}>`
  display: flex;
  justify-content: center;
  gap: 4em;
  flex-direction: ${(p) => (p.reverse ? "row-reverse" : "row")};
  background-color: ${(p) => p.backgroundColor};

  ${({ pad }) => pad && `padding: ${pad} 0;`}

  ${ZIG_ZAG_BREAKPOINT} {
    flex-direction: column;
    gap: 3rem;
    align-items: center;
    padding: 0 2rem;
  }
`;

const TextContainer = styled.div`
  width: 30rem;

  ${ZIG_ZAG_BREAKPOINT} {
    width: 34rem;
  }

  ${mobile} {
    width: 100%;
  }
`;

const FormContainer = styled.div`
  width: 34rem;

  img {
    width: 100%;
    height: auto;
    display: block;
  }

  @media only screen and (max-width: 36rem) {
    width: 100%;
  }
`;
